import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import CFPHero from './CFPHero';
import CFPSection from '../home-3/CFPSection';
import { supabase } from '../../supabaseClient';
import defaultCfpData from '../../data/cfp.json';

const CFPPage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [cfpData, setCfpData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        
        const fetchCfpData = async () => {
            try {
                const { data, error } = await supabase
                    .from('cfp_page_content')
                    .select('*')
                    .eq('page_name', 'cfp-page')
                    .single();
                    
                if (error || !data) {
                    setCfpData(defaultCfpData);
                } else {
                    setCfpData(data.data);
                }
            } catch (err) {
                setCfpData(defaultCfpData);
            }
            setLoading(false);
        };
        
        fetchCfpData();

        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    if (loading) {
        return (
            <div className="homestyle2" style={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', background: 'var(--eventflow-black)' }}>
                <div className="spinner-border text-light" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <CFPHero cfpData={cfpData} />
            <CFPSection cfpData={cfpData} />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default CFPPage;
